import { render, staticRenderFns } from "./ProcessIndex.vue?vue&type=template&id=f2f6abf4&scoped=true"
import script from "./ProcessIndex.vue?vue&type=script&lang=js"
export * from "./ProcessIndex.vue?vue&type=script&lang=js"
import style0 from "./ProcessIndex.vue?vue&type=style&index=0&id=f2f6abf4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f6abf4",
  null
  
)

export default component.exports